import { render, staticRenderFns } from "./Teasers.vue?vue&type=template&id=3f04d5e4&scoped=true"
import script from "./Teasers.vue?vue&type=script&lang=js"
export * from "./Teasers.vue?vue&type=script&lang=js"
import style0 from "./Teasers.vue?vue&type=style&index=0&id=3f04d5e4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f04d5e4",
  null
  
)

export default component.exports